import type { CommonData } from '@/app/common/createCommonData.ts';
import { consentCategoryMeasurementGiven } from '@/app/common/utils/consentCategoryMeasurementGiven.ts';
import { ampli } from '@/ampli';
import type { Localization } from '@/app/components/search/common/Localization';

export const canInitialiseAmplitude = (commonData: CommonData, localization: Localization): boolean =>
  localization.configValuesApp.amplitudeEnabled && consentCategoryMeasurementGiven(commonData);

export const canUseAmplitude = (commonData: CommonData, localization: Localization) =>
  localization.configValuesApp.amplitudeEnabled && consentCategoryMeasurementGiven(commonData) && ampli.isLoaded;
